import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'vue-cookie'

import category from './category.js'
import khazanah from './khazanah.js'
import khazanahBab from './khazanahBab.js'
import quran from './quran.js'
import quranSurah from './quranSurah.js'
import auth from './auth.js'
import bookmark from './bookmark.js'

import quranAyat from './quranAyat.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: cookie.get('token'),
        terjemahan_bait: true,
        terjemahan_kata: true,
        harokat: true,
        detail: true,
        userProfile: JSON.parse(cookie.get('userProfile')) || {
            name: '',
            email: '',
            image: ''
        },
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload
        },
        SET_ERRORS(state, payload) {
            state.errors = payload
        },
        CLEAR_ERRORS(state) {
            state.errors = []
        },
        SET_TERJEMAHAN_BAIT(state, payload) {
            state.terjemahan_bait = payload
        },
        SET_TERJEMAHAN_KATA(state, payload) {
            state.terjemahan_kata = payload
        },
        SET_HAROKAT(state, payload) {
            state.harokat = payload
        },
        SET_DETAIL(state, payload) {
            state.detail = payload
        },
        SET_PROFILE(state, payload) {
            state.userProfile = payload;
            cookie.set('userProfile', JSON.stringify(payload));
        }
    },
    actions: {
        changeTerjemahanBait({ commit }, value) {
            commit("SET_TERJEMAHAN_BAIT", value)
        },
        changeTerjemahanKata({ commit }, value) {
            commit("SET_TERJEMAHAN_KATA", value)
        },
        changeHarokat({ commit }, value) {
            commit("SET_HAROKAT", value)
        },
        changeDetail({ commit }, value) {
            commit("SET_DETAIL", value)
        },
        changeProfile({ commit }, payload) {
            commit("SET_PROFILE", payload)
        }
    },
    modules: {
        category, khazanah, khazanahBab, quran, quranSurah, auth, bookmark, quranAyat
    }
})